import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private router: Router) {}

  public showNotify(message, type, time: number = 2500) {
    notify(
      { message, position: { my: 'center top', at: 'center top' } },
      type,
      time,
    );
  }

  public showNotifyWithLink(
    message: string,
    linkCommands: any[],
    type: string,
    time: number = 2500,
    linkText?: string | null,
    queryParams?: Record<string, string>,
  ) {
    const href = this.router.serializeUrl(
      this.router.createUrlTree(linkCommands, { queryParams }),
    );

    notify(
      {
        position: { my: 'center top', at: 'center top' },
        displayTime: time,
        contentTemplate: element => {
          const container = document.createElement('div');
          container.style.cursor = 'pointer';
          const text = document.createTextNode(message);
          const hasLinkText = !!linkText;
          const space = hasLinkText ? document.createTextNode(' ') : null;
          const link = hasLinkText ? document.createElement('a') : null;

          if (link && space) {
            link.href = href;
            link.innerText = linkText as string;
            link.addEventListener('click', event => {
              event.preventDefault();
              this.router.navigate(linkCommands, { queryParams });
            });
          }

          container.addEventListener('click', event => {
            event.preventDefault();
            this.router.navigate(linkCommands, { queryParams });
          });

          container.appendChild(text);
          if (space && link) {
            container.appendChild(space);
            container.appendChild(link);
          }

          element.appendChild(container);

          return element;
        },
      },
      type,
      time,
    );
  }

  public showSuccessMessage(message, time: number = 2500) {
    this.showNotify(message, 'success', time);
  }

  public showErrorMessage(message, time: number = 5000) {
    this.showNotify(message, 'error', time);
  }
}
